import React, { useCallback, useMemo } from 'react'
import { Form, Space, Spin } from 'antd'
import { filter, includes, values } from 'lodash'
import PropTypes from 'prop-types'

import { FormButtons, FormSelect } from '../../../common/components/sections'
import {
  DROPDOWN_MIN_WIDTH,
  METADATA_TYPES,
  PERMISSIONS,
} from '../../../common/constants'
import { useFormDirty } from '../../../common/hooks'
import { filterSelectOptions } from '../../../common/utils'

const MetadataNodesForm = ({ isGeneratingReport, onSubmit }) => {
  const [form] = Form.useForm()
  const { setToDirty, resetForm } = useFormDirty(form)

  const metadataTypeOptions = useMemo(
    () =>
      filter(values(METADATA_TYPES), ({ value }) =>
        includes(
          [
            METADATA_TYPES.INGREDIENTS.value,
            METADATA_TYPES.ALLERGENS.value,
            METADATA_TYPES.DIETS.value,
            METADATA_TYPES.DISH_TYPES.value,
            METADATA_TYPES.COURSE_TYPES.value,
            METADATA_TYPES.CUISINE_TYPES.value,
            METADATA_TYPES.LOCATION_TYPES.value,
          ],
          value,
        ),
      ),
    [],
  )

  const handleFilter = useCallback(
    data => {
      onSubmit(data)
    },
    [onSubmit],
  )

  if (isGeneratingReport) {
    return <Spin />
  }

  return (
    <Form form={form} onFinish={handleFilter} onFieldsChange={setToDirty}>
      <Space>
        <FormSelect
          name="metadataTypes"
          showSearch
          allowClear
          labelAbove
          label="Metadata Types"
          filterOption={filterSelectOptions}
          options={metadataTypeOptions}
          maxTagCount={2}
          mode="multiple"
          placeholder="Select by metadata types..."
          dropdownMatchSelectWidth={DROPDOWN_MIN_WIDTH}
          style={{ minWidth: 200 }}
        />
      </Space>

      <FormButtons
        permissions={[PERMISSIONS.REPORT.METADATA_NODES]}
        onReset={resetForm}
        saveText="Search"
      />
    </Form>
  )
}

MetadataNodesForm.propTypes = {
  isGeneratingReport: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
}

MetadataNodesForm.defaultProps = {
  isGeneratingReport: false,
}

export default MetadataNodesForm
